import { Controller } from "stimulus"
import OS from "../lib/os"

export default class OSController extends Controller {

  os = new OS()
  static get targets() {
    return ['icon']
  }
  initialize() {
    let icon = 'i-windows'
    if (this.os.macos()) {
      icon = 'i-apple'
    }
    if (this.os.linux()) {
      icon = 'i-linux'
    }
    if (this.iconTarget) {
      this.iconTarget.className = icon
      this.iconTarget.innerHTML = ""
    }
  }

}